<template>
  <DataComboBox :value="value" @input="$emit('input',$event)" :config="config" />
</template>

<script>
import DataComboBox from "../../ui/controls/DataComboBox.vue";

export default {
  name: "WorkflowPicker",
  
  components: { DataComboBox },

  props: ["value", "title", "isRequired"],

  data() {
    return {
      config: {
        title: this.title,
        listDataSource: "workflows/query",
        listTextField: "name",
        listValueField: "name",
        isRequired: this.isRequired
      }
    };
  }
};
</script>
